import { createFileRoute } from "@tanstack/react-router";

import InvoiceDetail from "./-components/InvoiceDetail";

export const Route = createFileRoute(
  "/_app/_dashboard/subscription/invoices/$invoiceId"
)({
  component: InvoiceDetail,
});
